<template>
    <!-- Copyright -->
    <div class="copyright">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <img class="img-fluid" src="../assets/images/Arcane_White_Logo.png" style="height: 80px;padding: 1em;">
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <p class="p-small">Copyright © 2021, Arcane Spectacles.</p>
                </div> <!-- end of col -->
            </div> <!-- enf of row -->
        </div> <!-- end of container -->
    </div> <!-- end of copyright --> 
    <!-- end of copyright -->
</template>

<script>
export default {
  name: 'CopyrightSection'
}
</script>


// WEBPACK FOOTER //
// src/components/CopyrightSection.vue